import React from "react";

const FormLabel = ({ children, required = false, style = {}, ...rest }) => {
  return (
    <label
      style={{
        fontSize: "14px",
        fontWeight: 400,
        color: "var(--text-secondary, #6c757d)",
        fontFamily: "var(--font-family, 'Segoe UI', sans-serif)",
        marginBottom: "0.25rem",
        display: "inline-block",
        ...style,
      }}
      {...rest}
    >
      {children}
      {required && <span style={{ color: "var(--states-alert, #dc3545)" }}> *</span>}
    </label>
  );
};

export default FormLabel;